import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  ChangeEvent,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import Grid from '@material-ui/core/Grid';
import { BsTrash } from 'react-icons/bs';

import api from '../../../../../../../services/api';

import {
  TabWrapper,
  DrawerTabTitle,
  RadioDisponibilidadeWrapper,
  DisponibilidadeWrapper,
  SelectTurno,
  AddButton,
  ButtonAction,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';
import material_styles from '../../../drawer_styles/material_styles';
import { useToast } from '../../../../../../../hooks/toast';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';
import { useEditProduto } from '../../../../../../../hooks/editProduto';
import { useAuth } from '../../../../../../../hooks/auth';

import schedulesOptions from '../../../../../utils/schedulesOptions';

interface TurnoType {
  inicio: number;
  fim: number;
}

interface DisponibilidadeProps {
  produto_id: number;
}

interface QtdTurnos {
  index: number;
}

const Disponibilidade: React.FC<DisponibilidadeProps> = ({ produto_id }) => {
  const {
    disponibilidade,
    turnos,
    sempreDisponivel,
    qtdTurnos,
    produto,
    handleSetQtdTurno,
    handleSetTurnos,
    handleSetSempreDisponivel,
    handleSetDisponibilidade: handleSetDisponibilidadeGlobal,
  } = useEditProduto();

  const [days, setDays] = useState(disponibilidade.dias);
  const [btnDisable, setBtnDisable] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();

  const { addToast } = useToast();
  const { user } = useAuth();
  const {
    handleSetDrawerWasClosed,
    handleSetHasProductUpdated,
  } = useRegisterAdded();

  const handleChangeDay = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const daysUpdated = days;

      switch (value) {
        case 'domingo':
          daysUpdated.domingo = !daysUpdated.domingo;
          break;
        case 'segunda':
          daysUpdated.segunda = !daysUpdated.segunda;
          break;
        case 'terca':
          daysUpdated.terca = !daysUpdated.terca;
          break;
        case 'quarta':
          daysUpdated.quarta = !daysUpdated.quarta;
          break;
        case 'quinta':
          daysUpdated.quinta = !daysUpdated.quinta;
          break;
        case 'sexta':
          daysUpdated.sexta = !daysUpdated.sexta;
          break;
        case 'sabado':
          daysUpdated.sabado = !daysUpdated.sabado;
          break;
        default:
          return;
      }

      handleSetDisponibilidadeGlobal({
        ...disponibilidade,
        dias: { ...daysUpdated },
      });
    },
    [days],
  );

  const handleChangeTurno = useCallback(
    (e: any, item_index: number, turno: string) => {
      const newTurnoState = [...turnos];

      if (turno === 'inicio') newTurnoState[item_index].inicio = e.value;
      else if (turno === 'fim') newTurnoState[item_index].fim = e.value;

      handleSetTurnos([...newTurnoState]);
    },
    [turnos, handleSetTurnos],
  );

  const handleSetDisponibilidade = useCallback(
    (invisible: boolean) => {
      handleSetSempreDisponivel(invisible);
    },
    [handleSetSempreDisponivel],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        setBtnDisable(true);
        const keys = Object.entries(data);
        const turnoType: TurnoType[] = [];

        let role;

        if (sempreDisponivel) {
          role = {
            dias: {
              domingo: true,
              segunda: true,
              terca: true,
              quarta: true,
              quinta: true,
              sexta: true,
              sabado: true,
            },
            turnos: [],
          };
        }

        if (qtdTurnos.length == 0 && !sempreDisponivel) {
          role = {
            dias: days,
            turnos: [],
          };
        } else if (!sempreDisponivel) {
          for (let i = 0; i < qtdTurnos.length; i += 1) {
            const index = i * 2;

            const inicio = Number(keys[index][1]);
            const fim = Number(keys[index + 1][1]);

            if (inicio > fim) {
              addToast({
                type: 'error',
                title: 'Turno inválido.',
                description: 'O início do turno deve ser maior que o fim',
              });
              setBtnDisable(false);

              return;
            }

            const turnoObjectType: TurnoType = {
              inicio,
              fim,
            };

            turnoType.push(turnoObjectType);
          }

          role = {
            dias: days,
            turnos: turnoType,
          };
        }

        const productWillBeStored = {
          unidade_medida_id: produto.unidade_medida_id,
          descricao: produto.descricao,
          codigo: produto.codigo ? produto.codigo : null,
          gtin: produto.gtin ? produto.gtin : null,
          observacao: produto.observacao,
          empresa_id: user.empresa_id,
          grupo_id: produto.grupo_id,
        };

        await api.put(`/produto/${produto.id}`, {
          ...productWillBeStored,
        });

        await api.put(`/produto/preco/${produto.id}`, {
          valor: produto.preco,
          grupo_id: productWillBeStored.grupo_id,
        });

        await api.put(`/estoque/${produto.id}`, {
          estoque_minimo: produto.estoque_minimo,
          estoque_atual: produto.estoque_atual,
        });

        await api.put(`/produto/disponibilidade/${produto_id}`, { role });

        setBtnDisable(false);
        addToast({
          type: 'success',
          title: 'Produto Atualizado',
        });
        handleSetDrawerWasClosed(true);
        handleSetHasProductUpdated(true);
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [
      produto_id,
      days,
      sempreDisponivel,
      qtdTurnos,
      produto,
      handleSetHasProductUpdated,
      user,
    ],
  );

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Disponibilidade</h1>
        <span>
          Defina os momentos em que os clientes poderão comprar este item.
        </span>
      </DrawerTabTitle>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.noPaddingBot}>
            <RadioDisponibilidadeWrapper>
              <form>
                <div>
                  <label htmlFor="no_have">
                    <input
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      checked={sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(true)}
                    />
                    Sempre Disponível
                  </label>
                  <span>
                    O item ficará disponível sempre que o restaurante estiver
                    aberto
                  </span>
                </div>

                <div>
                  <label htmlFor="have">
                    <input
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      checked={!sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(false)}
                    />
                    Disponível em dias e horários específicos
                  </label>
                  <span>Selecione os dias que o item estará disponível</span>
                </div>
              </form>
            </RadioDisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingTop}>
            <DisponibilidadeWrapper isInvisible={sempreDisponivel}>
              <div className="dias">
                <span>Dias da Semana</span>

                <input
                  type="checkbox"
                  id="domingo"
                  name="domingo"
                  value="domingo"
                  onChange={handleChangeDay}
                  checked={days.domingo}
                />
                <label htmlFor="domingo">D</label>

                <input
                  type="checkbox"
                  id="segunda"
                  name="segunda"
                  value="segunda"
                  onChange={handleChangeDay}
                  checked={days.segunda}
                />
                <label htmlFor="segunda">S</label>

                <input
                  type="checkbox"
                  id="terca"
                  name="terca"
                  value="terca"
                  onChange={handleChangeDay}
                  checked={days.terca}
                />
                <label htmlFor="terca">T</label>

                <input
                  type="checkbox"
                  id="quarta"
                  name="quarta"
                  value="quarta"
                  checked={days.quarta}
                  onChange={handleChangeDay}
                />
                <label htmlFor="quarta">Q</label>

                <input
                  type="checkbox"
                  id="quinta"
                  name="quinta"
                  value="quinta"
                  onChange={handleChangeDay}
                  checked={days.quinta}
                />
                <label htmlFor="quinta">Q</label>

                <input
                  type="checkbox"
                  id="sexta"
                  name="sexta"
                  value="sexta"
                  onChange={handleChangeDay}
                  checked={days.sexta}
                />
                <label htmlFor="sexta">S</label>

                <input
                  type="checkbox"
                  id="sabado"
                  name="sabado"
                  value="sabado"
                  onChange={handleChangeDay}
                  checked={days.sabado}
                />
                <label htmlFor="sabado">S</label>
              </div>

              <div className="turno_wrapper">
                <div className="title_wrapper">
                  <span>Horários</span>
                  <AddButton
                    type="button"
                    onClick={() => handleSetQtdTurno('add')}
                  >
                    + Adicionar Turno
                  </AddButton>
                </div>

                {qtdTurnos.map((item) => (
                  <>
                    {turnos.length > 0 && (
                      <div className="turnos_wrapper">
                        <div className="turno">
                          <span>{`${item.index + 1}º Turno`}</span>

                          <div>
                            <SelectTurno
                              name={`${item.index}turno_inicio`}
                              placeholder="Selecione"
                              options={schedulesOptions}
                              value={{
                                label: turnos[item.index].inicio.toString(),
                                value: turnos[item.index].inicio,
                              }}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleChangeTurno(e, item.index, 'inicio')
                              }
                            />
                          </div>

                          <div>
                            <SelectTurno
                              name={`${item.index}turno_fim`}
                              placeholder="Selecione"
                              options={schedulesOptions}
                              value={{
                                label: turnos[item.index].fim.toString(),
                                value: turnos[item.index].fim,
                              }}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                handleChangeTurno(e, item.index, 'fim')
                              }
                            />
                          </div>

                          <button
                            type="button"
                            onClick={() =>
                              handleSetQtdTurno('remove', item.index)
                            }
                          >
                            <BsTrash size={16} />
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ))}
              </div>
            </DisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={() => handleSetDrawerWasClosed(true)}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                disabled={btnDisable}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Disponibilidade;
